module.exports = __webpack_public_path__ + "static/img/14.fbf1758.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/14.png
// module id = 7qJC
// module chunks = 1